export const SET_CURRENT_STEP = '/navigation/SET_CURRENT_STEP';
export const SET_MENU = '/navigation/SET_MENU';
export const PREV_STEP = '/navigation/PREV_STEP';
export const NEXT_STEP = '/navigation/NEXT_STEP';
